import { render, staticRenderFns } from "./form-detail.vue?vue&type=template&id=32f5c3ca&"
import script from "./form-detail.vue?vue&type=script&lang=js&"
export * from "./form-detail.vue?vue&type=script&lang=js&"
import style0 from "./form-detail.vue?vue&type=style&index=0&id=32f5c3ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports